import Vue from 'vue'
import VueRouter from 'vue-router'
import BootstrapVue from 'bootstrap-vue'

Vue.use(VueRouter)
Vue.use(BootstrapVue)
import App from './App.vue'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false

import Tasks from '@/components/Tasks'

const routes = [
  { path: '/list/:taskListId', name: 'tasks', component: Tasks }
];
const router = new VueRouter({ routes })

import GAPI from './gapi'
let gapi = new GAPI(
    { CLIENT_ID: '825017879486-26q55ds9t0jqgkrvcak21lraq3uokbfi.apps.googleusercontent.com',
      API_KEY: 'AIzaSyBYmsUQxRsHQzKYNa9ql1szy9dF0MkT4NA' })
Object.defineProperty(Vue.prototype, '$gapi', { value: gapi })

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
